// src/core/online/NotificationManager.js

const NotificationManager = {
    // Basit bir tost bildirim sistemi
    show: function (message, type = 'info') {
        const notif = document.createElement('div');
        notif.innerText = message;
        Object.assign(notif.style, {
            position: 'fixed', top: '20px', left: '50%', transform: 'translateX(-50%)',
            padding: '12px 24px', borderRadius: '8px', zIndex: '10000',
            color: '#fff', fontWeight: 'bold', boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            background: type === 'error' ? '#e74c3c' : (type === 'success' ? '#2ecc71' : '#3498db'),
            transition: 'all 0.3s ease', opacity: '0', marginTop: '-20px'
        });
        document.body.appendChild(notif);

        setTimeout(() => {
            notif.style.opacity = '1';
            notif.style.marginTop = '0';
        }, 10);

        setTimeout(() => {
            notif.style.opacity = '0';
            notif.style.marginTop = '-20px';
            setTimeout(() => notif.remove(), 300);
        }, 3000);
    }
};

window.NotificationManager = NotificationManager;
